// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__2Znyv","table":"Table_table__3JYbR","row":"Table_row__3ivpc","col":"Table_col__DxLmF","status":"Table_status__21g1U"};